<div class="mb-3">
  <div>
    <h1 class="pb-2 border-bottom" i18n>
      Scan Provider @if (id) {
<span>(bearbeiten)</span>
}
      @if (!id) {
<span>(zuordnen)</span>
}
    </h1>

    <div class="mt-5">
      @if (bindingForm) {
        <form [formGroup]="bindingForm">
          <div class="row mt-3">
            <div class="col-sm-6">
              <app-form-row label="Kunde" i18n-label>
                <kendo-combobox
                  [data]="filteredCustomers"
                  formControlName="customerId"
                  textField="fullName"
                  valueField="id"
                  [valuePrimitive]="true"
                  [filterable]="true"
                  (filterChange)="onCustomerFilterChange($event)"
                  i18n-placeholder
                  placeholder="Kunde auswählen"
                ></kendo-combobox>
              </app-form-row>
              <app-form-row label="Provider" i18n-label>
                <kendo-dropdownlist
                  [data]="providers"
                  formControlName="providerKey"
                  textField="providerKey"
                  valueField="providerKey"
                  [valuePrimitive]="true"
                ></kendo-dropdownlist>
              </app-form-row>
              <app-form-row label="Root-URL" i18n-label>
                <input
                  type="text"
                  formControlName="rootUrl"
                  class="form-control form-control-sm"
                  placeholder="https://www.example-shop.de/"
                  />
                <ng-template appFieldError="pattern"><span i18n>Die Root-URL muss eine absolute http(s)-URL sein</span></ng-template>
              </app-form-row>
              <app-form-row label="Konfiguration (JSON)" i18n-label>
                <textarea
                  rows="5"
                  formControlName="providerConfigJson"
                  class="form-control form-control-sm font-monospace"
                ></textarea>

                @if (configExample) {
                  <div class="form-text">
                    <span i18n>Beispielkonfiguration für {{ f['providerKey'].value }}:</span>
                    <pre class="mb-1 small text-wrap">{{ configExample }}</pre>
                    <button
                      class="btn btn-outline-secondary btn-sm"
                      type="button"
                      (click)="applyConfigExample()"
                      [disabled]="f['providerConfigJson'].value"
                      i18n
                      >
                      Beispiel übernehmen
                    </button>
                  </div>
                }
                <ng-template appFieldError="invalidJson"><span i18n>Die Konfiguration muss gültiges JSON sein</span></ng-template>
              </app-form-row>
            </div>
            <div class="col-sm-6">
              <app-form-row label="Artikelkategorie" i18n-label>
                <!-- #633 D: optional — „keine" creates unresolved products deliberately
                     ohne Kategorie (sichtbarer Pflege-Rückstand). -->
                <kendo-dropdownlist
                  [data]="productCategories"
                  formControlName="defaultProductCategoryId"
                  textField="name"
                  valueField="id"
                  [valuePrimitive]="true"
                  [defaultItem]="noDefaultCategoryItem"
                ></kendo-dropdownlist>
              </app-form-row>
              <!-- Backend #538: named category-resolution profile. "beobachtend" (shadow) only
                   records what the chain would decide; "aktiv" applies it when listings are
                   created. Empty = house default. The Artikelkategorie above stays the
                   fallback either way. -->
              <app-form-row label="Kategorie-Ermittlung" i18n-label>
                <kendo-dropdownlist
                  [data]="profileItems"
                  formControlName="categoryResolutionProfileKey"
                  textField="label"
                  valueField="key"
                  [valuePrimitive]="true"
                  [defaultItem]="defaultProfileItem"
                ></kendo-dropdownlist>
                <small class="form-text text-muted" i18n>
                  „aktiv“ übernimmt die automatisch ermittelte Kategorie beim Anlegen neuer Artikel; „beobachtend“ zeichnet sie nur auf. Die Artikelkategorie oben bleibt der Rückfallwert.
                </small>
              </app-form-row>
              <!-- Backend #579 (slice 4): named VAT-resolution profile, the mirror of the category
                   one. "beobachtend" records only; "Vorschlag" stores the verdict on the listing
                   for the seller; "aktiv" applies it under the C rule — refused server-side until
                   the rulings and the AI evaluation are signed off. Empty = house default. -->
              <app-form-row label="MwSt.-Ermittlung" i18n-label>
                <kendo-dropdownlist
                  [data]="vatProfileItems"
                  formControlName="vatResolutionProfileKey"
                  textField="label"
                  valueField="key"
                  [valuePrimitive]="true"
                  [defaultItem]="defaultVatProfileItem"
                ></kendo-dropdownlist>
                <small class="form-text text-muted" i18n>
                  „beobachtend“ zeichnet den ermittelten MwSt.-Satz nur auf; „Vorschlag“ legt ihn dem Anbieter zur Entscheidung vor; „aktiv“ übernimmt ihn beim Anlegen neuer Artikel – und wird vom System abgelehnt, solange die Regeln und die KI-Bewertung nicht freigegeben sind. Der MwSt.-Satz oben bleibt der Rückfallwert.
                </small>
              </app-form-row>
              <!-- Backend #617: the shop's product-text language. Scopes which vocabulary
                   language groups the category/VAT resolution runs for this binding — a
                   German word like „Tee" (tea) and the English "tee" (T-shirt) resolve
                   correctly only once the language is declared. Never the tax jurisdiction:
                   English shops still map into the German rate set. -->
              <app-form-row label="Sprache der Produkttexte" i18n-label>
                <kendo-dropdownlist
                  [data]="contentLanguageItems"
                  formControlName="contentLanguage"
                  textField="label"
                  valueField="code"
                  [valuePrimitive]="true"
                  [defaultItem]="undeclaredLanguageItem"
                ></kendo-dropdownlist>
                <small class="form-text text-muted" i18n>
                  Steuert, welche Erkennungsbegriffe die automatische Kategorie- und MwSt.-Ermittlung für diesen Shop verwendet. „Nicht festgelegt“ berücksichtigt alle Sprachen; mehrdeutige Begriffe (z.&nbsp;B. „Tee“) bleiben dann unentschieden.
                </small>
              </app-form-row>
              <app-form-row label="MwSt.-Satz" i18n-label>
                <kendo-dropdownlist
                  [data]="vatItems"
                  formControlName="defaultVatId"
                  textField="label"
                  valueField="id"
                  [valuePrimitive]="true"
                  [defaultItem]="{ id: null, label: '—' }"
                ></kendo-dropdownlist>
              </app-form-row>
              <!-- Backend #525/#526: per-shop expected currency; outranks the seller's
                   Standardwährung. Empty = seller default → EUR. -->
              <app-form-row label="Erwartete Währung" i18n-label>
                <input
                  type="text"
                  formControlName="expectedCurrency"
                  class="form-control form-control-sm"
                  maxlength="3"
                  i18n-placeholder
                  placeholder="z. B. EUR"
                />
                <small class="form-text text-muted" i18n>
                  Gescannte Produkte mit abweichender Währung werden nicht übernommen. Leer = Standardwährung des Kunden.
                </small>
                <ng-template appFieldError="pattern"><span i18n>Bitte einen 3-buchstabigen ISO-4217-Code angeben (z. B. EUR).</span></ng-template>
              </app-form-row>
              <app-form-row label="Intervall (Min.)" i18n-label>
                <input
                  type="number"
                  formControlName="cadenceMinutes"
                  class="form-control form-control-sm"
                  />
                <ng-template appFieldError="min"><span i18n>Das Intervall muss mindestens 1 Minute betragen</span></ng-template>
              </app-form-row>
              <app-form-row label="Status" i18n-label>
                <div class="form-check mt-2">
                  <input
                    name="isEnabled"
                    id="isEnabled"
                    class="form-check-input"
                    type="checkbox"
                    formControlName="isEnabled"
                    />
                  <label for="isEnabled" class="form-check-label" i18n>Scan ist aktiv</label>
                </div>
              </app-form-row>
            </div>
          </div>
          <div class="d-flex justify-content-end gap-2 mt-4">
            <button class="btn btn-secondary" type="button" (click)="onBackClicked()" i18n>
              Zurück
            </button>
            <button
              class="btn btn-primary"
              type="button"
              [asyncClick]="submitForm.bind(this)"
              [disabled]="saveBtn.disabled || bindingForm.pristine || bindingForm.invalid"
              #saveBtn="asyncClick"
              >
              @if (saveBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
              <ng-container i18n>Bestätigen</ng-container>
            </button>
          </div>
        </form>
      }
    </div>
  </div>
</div>
